import { useField } from "formik";
import { FC, useCallback } from "react";
import { ContactAttributeOption } from "../shared/types";
import { EditSortableContactAttributes } from "./EditSortableContactAttributes";

interface Props {
	name: string;
}

export const EditSortableContactAttributesField: FC<Props> = ({ name }) => {
	const [field, meta, helpers] = useField<ContactAttributeOption[]>(name);

	const onChange = useCallback(
		(value: ContactAttributeOption[]) => {
			const values = value.filter((v) => v);
			void helpers.setValue(values);
		},
		[helpers],
	);

	return (
		<EditSortableContactAttributes
			value={field.value}
			onChange={onChange}
			error={meta.touched ? meta.error : undefined}
		/>
	);
};
